import React, { Component } from 'react';
import PrimaryButtonGE from 'src/Components/PrimaryButtonGE/PrimaryButtonGE';
import { infoConstants } from './infoConstants';
import './styles.scss';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { getProfileDetails } from 'src/Actions/Profile/profileActions';
import { PulseLoader } from 'react-spinners';


export class Info extends Component {

  componentDidMount(){
    this.props.getProfileDetails();
  }
  renewSubscription = () => {
    window.open(
      'https://www.gehealthcare.com/products/ultrasound/ultrasound-digital-solutions/digital-expert',
      '_blank'
    );
  };

  render() {
    localStorage.setItem('activeItem', 'Info');
    const { C2CExpired, GE2CExpired, noSubscriptionActive } = this.props.subscription;
    let { profileDetails } = this.props.profile;
    let activeKey = "";
    let displayName = "";
    if (noSubscriptionActive) {
      activeKey = "noAccess";
    }
    else if (GE2CExpired || C2CExpired) {
      activeKey = "expiredSub";
    }
    else {
      displayName = profileDetails?.firstName;
      activeKey = "getStarted";
    }
    
    return (
      <div
        className="info-screen-wrapper"
        style={{ padding: '0' }}
      >
        {this.props.generic.initialLoad ? <div className='init-loader'>
          <PulseLoader color={'#ffffff'} style={{ marginBottom: 24, marginTop: 24 }} />
        </div> :<>
        {profileDetails == null || (activeKey === "getStarted" && !displayName)?
          <div></div> :
          <div className="info-container">
            <h3 className={`heading__info ${activeKey === 'noAccess' ? 'noaccess' : ''}`}>
              {infoConstants[activeKey].pageHeading}&nbsp;{displayName}
            </h3>
            <p className="heading-helper-text__info">
              {infoConstants[activeKey].headingHelperText}
            </p>
            <hr className="separator" />
            <p className="lower-half-data__info">
              {infoConstants[activeKey].cardListHeading}
            </p>
            <PrimaryButtonGE
              text={infoConstants[activeKey].buttonText}
              className="cta-button__info"
              onClick={this.renewSubscription}
            />
          </div>
        }
        </>}
      </div>
    );
  }
}

const mapStateToProps = ({ profile, subscription,generic }) => ({
  profile,
  subscription,
  generic
});

const mapDispatchToProps = (dispatch) => ({
getProfileDetails: () => dispatch(getProfileDetails()),})

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(Info));
